import React from "react";

// controllers
import { ProductController } from "controllers";
import { AppContext } from "components";

// styles imports
import { withStyles } from '@material-ui/styles';
import productStyles from "../../styles/Product/styles";
import styles from "../../containers/Product/Create/ProductCreateContainer.module.scss";

// material
import SearchBar from "material-ui-search-bar";
import { List, ListItem, ListItemText } from "@material-ui/core";
import { FormGroup } from "reactstrap";

//redux
import { connect } from 'react-redux'

const mapStateToProps = (state, ownProps) => {
    return { ...ownProps, country: state.countries.value }
}

class ProductSearch extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            key: "",
            filteredProducts: [],
            selectedProduct: null,
            loading: false
        };

        this.getProductByValue = this.getProductByValue.bind(this);
        this.search = this.search.bind(this);
        this.selectProduct = this.selectProduct.bind(this);
        this.resetState = this.resetState.bind(this);
        this.emitChange = this.emitChange.bind(this);
    }

    componentDidMount() {
        this.getProductByValue(this.props.value);
    }

    componentDidUpdate(prevProps) {
        // `value` should be product barcode
        if (this.props.value !== prevProps.value) {
            this.getProductByValue(this.props.value);
        }

        if (this.props.key !== prevProps.key) {
            this.setState({ key: this.props.key });
        }
    }

    async getProductByValue(barcode) {
        const { country } = this.props

        if (!barcode) {
            return;
        }

        ProductController.getProductByFieldQuery('barcode', barcode, 5, country)
            .then((result) => {
                const product = result;
                if (product) {
                    this.setState({ selectedProduct: product, key: product.barcode });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    async search(text) {
        const { excludedProducts, country } = this.props;

        this.setState({ key: text, selectedProduct: null });

        let filteredProducts = [];
        if (text !== "" && text.length > 1) {
            this.context.showLoading();

            const limit = (excludedProducts ? excludedProducts.length : 0) + 15;

            filteredProducts = await ProductController.getProductByFieldQuery('barcode', text, limit, country);
            filteredProducts = filteredProducts.filter((p) => p.status === 'available');

            if (excludedProducts) {
                filteredProducts = filteredProducts.filter((p) => !(excludedProducts.indexOf(p.barcode) > -1));
            }

            this.context.hideLoading();
            this.setState({ loading: false });
        } else {
            filteredProducts = [];
        }

        this.setState({ filteredProducts });
    };

    selectProduct(product) {
        this.setState({
            selectedProduct: product,
            key: product.barcode,
            filteredProducts: []
        });

        this.emitChange(product);
    };

    resetState() {
        this.setState(
            {
                key: "",
                filteredProducts: [],
                selectedProduct: null,
                loading: false
            }
        );

        this.emitChange(null);
    }

    emitChange(value) {
        if (this.props.onChange) {
            this.props.onChange(value);
        }
    }

    render() {
        const { key, filteredProducts, loading } = this.state;

        return (
            <FormGroup className="relative-area">
                <React.Fragment>
                    <SearchBar
                        onChange={val => this.search(val)}
                        onRequestSearch={() => this.search(key)}
                        onCancelSearch={() => this.resetState()}
                        placeholder="Search Product"
                        value={key} />

                    {!loading && filteredProducts.length !== 0 && (
                        <List
                            className={styles.listbox}
                            style={{
                                position: "absolute",
                                marginTop: 10,
                                width: "100%",
                                zIndex: 999,
                                backgroundColor: "#FFF"
                            }}
                        >
                            {filteredProducts.map((product, index) => (
                                <ListItem
                                    className={styles.item}
                                    key={index}
                                    style={{
                                        borderBottom: "1px solid lightgrey"
                                    }}
                                    button
                                >
                                    <ListItemText
                                        primary={product.barcode}
                                        onClick={() => this.selectProduct(product)}
                                    />
                                </ListItem>
                            ))}
                        </List>
                    )}
                </React.Fragment>
            </FormGroup>
        );
    }
}

ProductSearch.contextType = AppContext;

export default connect(mapStateToProps)(withStyles(productStyles)(ProductSearch));
